import React, { useContext, useMemo } from 'react';
import { DateTime } from 'luxon';

type NoteContextValue = {
  date: DateTime;
};

const NoteContext = React.createContext<NoteContextValue | null>(null);

export const useNoteContext = (): NoteContextValue => {
  const val = useContext(NoteContext);
  if (!val) {
    throw new Error(
      'useNoteContext must be called within a NoteContextProvider'
    );
  }

  return val;
};

type NoteContextProviderProps = {
  date: DateTime;
  children: React.ReactNode;
};

export const NoteContextProvider: React.FC<NoteContextProviderProps> = ({
  date,
  children
}: NoteContextProviderProps) => {
  return (
    <NoteContext.Provider
      value={useMemo(
        () => ({
          date
        }),
        [date]
      )}
    >
      {children}
    </NoteContext.Provider>
  );
};
